import {
  IValidatorRules,
  registerValidateLocale,
  registerValidateRules,
  setValidateLanguage
} from '@formily/validator'
import { isInteger } from 'lodash'

import { isEmpty } from '@eastcoal/common/utils/object'

export const setupFormily = () => {
  setValidateLanguage('zh-CN')

  registerValidateLocale({
    'zh-CN': {
      // {{ field.title }}
      required: '{{ field.title }}不能为空',
      precision: '{{ field.title }}最多保持 {{precision}} 位小数',
      minium: '{{ field.title }}必须大于等于 {{minimum}}',
      exclusiveMinimum: '{{ field.title }}必须大于 {{exclusiveMinimum}}',
      maxium: '{{ field.title }}必须小于等于 {{maxium}}',
      exclusiveMaxium: '{{ field.title }}必须小于 {{exclusiveMaxium}}'
    }
  })

  registerValidateRules({
    required(value: any, rule: IValidatorRules<any>) {
      if (rule.required === false) return ''

      let flag = isEmpty(value)

      if (!flag && typeof value === 'object') {
        const keys = Object.keys(value)
        flag = keys.every(key => isEmpty(value[key]))
      }

      return flag ? (rule.message ?? '') : ''
    },
    precision(value: any, rule: IValidatorRules<any>) {
      if (isEmpty(value)) {
        return ''
      }

      return isInteger(Number(value) * Math.pow(10, Number(rule.precision)))
        ? ''
        : (rule.message ?? '')
    }
  })
}
